module.exports = __webpack_public_path__ + "static/media/仓间调拨_09.290cb561.png";